import React, { useState } from "react";

import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";

function AdminTemplate({ children, navigations }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-y-auto">
      <Sidebar
        navigations={navigations}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />

      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden" >
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <main className="h-full" >
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto" >
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}

export default AdminTemplate;
